import React from "react"

const InstagramGrid: React.FC = () => {
  return (
    <>
      <div className="yotpo yotpo-pictures-widget" data-gallery-id="64a664a0761047001d706902"></div>
    </>
  )
}

export default React.memo(InstagramGrid)
